import axios from "axios";
import JSZip from "jszip";
import { storageUrlWithCredentials } from "../components/imagesPreview/storageUrlWithCredentials";
import { saveAsFile } from "./saveAsFile";

export const api = axios.create({
  timeout: 30 * 1000, // 30s
});

interface ImageDetails {
  readonly name: string;
  readonly url: string;
  readonly source?: string;
  readonly info?: string;
}

export const useDownloadImages = () => {
  const download = async (images: ImageDetails[], { zipFileName = "images.zip" }: { zipFileName?: string } = {}) => {
    const zip = new JSZip();
    const blob = new Blob([generateMetadata(images)], {
      type: "text/csv;charset=utf-8;",
    });
    zip.file("metadane.csv", blob);
    const downloadedImages = await Promise.all(images.map((i) => downloadImage(i.name, i.url)));
    downloadedImages.forEach(({ name, data }) => zip.file(name, data));
    const zipFile = await zip.generateAsync({ type: "blob" });
    await saveAsFile(zipFile, zipFileName);
  };
  return { download };
};

async function downloadImage(name: string, url: string) {
  const signedUrl = await storageUrlWithCredentials(url);
  if (!signedUrl) {
    throw new Error(`Unable to generate signed url with credentials for [${url}]`);
  }
  const fileResponse = await api.get(signedUrl, { responseType: "blob" });
  return { name, data: fileResponse.data };
}

function generateMetadata(images: ImageDetails[]) {
  const header = "Nazwa,Źródło,Informacje";
  const rows = images.map(({ name, info, source }) => `${name ?? ""},${source ?? ""},${info ?? ""}`);
  return [header, ...rows].join("\n");
}
